/**
 * Time Format Preference
 *
 * Stores and retrieves the user's 12h / 24h display preference.
 * Backed by localStorage so the preference persists across sessions.
 *
 * The value is intentionally module-level so appointmentTimeUtils can
 * read it synchronously without React context.
 *
 * Usage:
 *   getIs24Hour()          → boolean
 *   setTimeFormat('24h')   → void
 *   setTimeFormat('12h')   → void
 */

const PREF_KEY = 'vela_time_format';

/**
 * Returns true when the user has selected 24-hour time display.
 * Defaults to false (12-hour) when no preference is stored.
 *
 * @returns {boolean}
 */
export function getIs24Hour() {
  try {
    return localStorage.getItem(PREF_KEY) === '24h';
  } catch {
    return false;
  }
}

/**
 * Persists the time format preference.
 *
 * @param {'12h' | '24h'} format
 */
export function setTimeFormat(format) {
  try {
    localStorage.setItem(PREF_KEY, format);
  } catch {
    // localStorage unavailable (e.g. SSR or private mode) — no-op
  }
}
